import React from 'react';
import './Contact.css';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="section-header">
          <motion.div 
            className="section-label"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            CONTACT US
          </motion.div>
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            GET IN TOUCH
          </motion.h2>
          <motion.p
            className="contact-desc"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            Any questions or remarks? Just write us a message!
          </motion.p>
        </div>

        <form
          className="contact-form"
          action="https://formsubmit.co/tagtrousers@gmail.com"
          method="POST"
        >
          {/* ── Formsubmit hidden config fields ── */}
          {/* Custom email subject */}
          <input type="hidden" name="_subject" value="New Enquiry from TAG Menswear Website" />
          {/* Disable captcha (set to "true" to enable) */}
          <input type="hidden" name="_captcha" value="false" />
          {/* Use the "table" email template for a clean format */}
          <input type="hidden" name="_template" value="table" />
          {/* Redirect to a thank-you page after submit */}
          <input type="hidden" name="_next" value="https://tagmenswear.com/thank-you" />

          {/* ── Name & Email ── */}
          <div className="form-row">
            <div className="input-group">
              <label htmlFor="contact-name">Name</label>
              <input
                id="contact-name"
                type="text"
                name="name"
                placeholder="Enter your Name"
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="contact-email">Email</label>
              <input
                id="contact-email"
                type="email"
                name="email"
                placeholder="Enter a valid email address"
                required
              />
            </div>
          </div>

          {/* ── Phone & Subject ── */}
          <div className="form-row">
            <div className="input-group">
              <label htmlFor="contact-phone">Phone Number</label>
              <input
                id="contact-phone"
                type="tel"
                name="phone"
                placeholder="Enter your phone number"
              />
            </div>
            <div className="input-group">
              <label htmlFor="contact-subject">Subject</label>
              <input
                id="contact-subject"
                type="text"
                name="subject"
                placeholder="What is this about?"
              />
            </div>
          </div>

          {/* ── Message ── */}
          <div className="input-group input-group--full">
            <label htmlFor="contact-message">Message</label>
            <textarea
              id="contact-message"
              name="message"
              rows="5"
              placeholder="Write your message here..."
              required
            />
          </div>

          <button type="submit" className="submit-btn">SEND MESSAGE</button>
        </form>

        <div className="contact-info-grid">
          <motion.div 
            className="info-card"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <div className="info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
            </div>
            <h3>EMAIL</h3>
            <p>tagtrousers@gmail.com</p>
          </motion.div>

          <motion.div 
            className="info-card"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <div className="info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
            </div>
            <h3>PHONE (LANDLINE)</h3>
            <p>04426420956</p>
            <p>+91-7947151361</p>
          </motion.div>

          <motion.div 
            className="info-card"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <div className="info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
            </div>
            <h3>OUR OFFICE LOCATION</h3>
            <p>49, Gangadeeshwar Koil St,</p>
            <p> Purasaiwakkam, Chennai,</p>
              <p> Tamil Nadu 600084</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
